if (!customElements.get('product-grid-view')) {
  customElements.define(
    'product-grid-view',
    class ProductGridView extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.section = this.closest('[data-product-grid-section]');
        this.buttons = Array.from(this.querySelectorAll('[data-product-grid-view-option]'));

        if (!this.section || this.buttons.length === 0) return;

        this.dataset.initialized = 'true';

        const savedView = window.Shopify?.designMode ? null : this.getSavedView();
        const defaultView = this.dataset.defaultView === 'list' ? 'list' : 'grid';
        const currentView = this.section.dataset.productGridView === 'list' ? 'list' : 'grid';
        this.setView(savedView || currentView || defaultView, false);

        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-product-grid-view-option]');
          if (!button || !this.contains(button)) return;

          this.setView(button.dataset.productGridViewOption, true);
        });
      }

      getSavedView() {
        try {
          const value = window.localStorage.getItem(this.dataset.storageKey);
          return value === 'grid' || value === 'list' ? value : null;
        } catch (error) {
          return null;
        }
      }

      setView(view, persist) {
        const nextView = view === 'list' ? 'list' : 'grid';
        this.section.dataset.productGridView = nextView;

        this.buttons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.productGridViewOption === nextView));
        });

        if (!persist || window.Shopify?.designMode) return;

        try {
          window.localStorage.setItem(this.dataset.storageKey, nextView);
        } catch (error) {
          // The selected view still works for this page when storage is unavailable.
        }
      }
    }
  );
}
